import { starterDeck } from "../builder";

export const DE_RU_BASIC = starterDeck({
  id: "de-ru-basic-a1",
  name: "Немецкий — основы",
  name_en: "German — Basics",
  description: "Базовые немецкие фразы и повседневная лексика.",
  description_en: "Basic German phrases and everyday vocabulary.",
  sourceLang: "de",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Hallo", "Привет"],
    ["Guten Morgen", "Доброе утро"],
    ["Guten Tag", "Добрый день"],
    ["Guten Abend", "Добрый вечер"],
    ["Auf Wiedersehen", "До свидания"],
    ["Tschüss", "Пока"],
    ["Bitte", "Пожалуйста"],
    ["Danke", "Спасибо"],
    ["Entschuldigung", "Извините"],
    ["Ja", "Да"],
    ["Nein", "Нет"],
    ["Wie geht's?", "Как дела?", "phrase"],
    ["Mir geht's gut", "У меня всё хорошо", "phrase"],
    ["Wie heißt du?", "Как тебя зовут?", "phrase"],
    ["Ich heiße…", "Меня зовут…", "phrase"],
    ["Ich verstehe nicht", "Я не понимаю", "phrase"],
    ["Sprechen Sie Englisch?", "Вы говорите по-английски?", "phrase"],
    ["Wasser", "вода"],
    ["Brot", "хлеб"],
    ["Bier", "пиво"],
  ],
});

export const FR_RU_BASIC = starterDeck({
  id: "fr-ru-basic-a1",
  name: "Французский — основы",
  name_en: "French — Basics",
  description: "Базовые французские фразы и повседневная лексика.",
  description_en: "Basic French phrases and everyday vocabulary.",
  sourceLang: "fr",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Bonjour", "Добрый день / Здравствуйте"],
    ["Bonsoir", "Добрый вечер"],
    ["Salut", "Привет (неформально)"],
    ["Au revoir", "До свидания"],
    ["Merci", "Спасибо"],
    ["Merci beaucoup", "Большое спасибо", "phrase"],
    ["S'il vous plaît", "Пожалуйста (вежливо)", "phrase"],
    ["Pardon", "Извините"],
    ["Excusez-moi", "Простите меня", "phrase"],
    ["Oui", "Да"],
    ["Non", "Нет"],
    ["Comment ça va ?", "Как дела?", "phrase"],
    ["Ça va bien", "Всё хорошо", "phrase"],
    ["Comment tu t'appelles ?", "Как тебя зовут?", "phrase"],
    ["Je m'appelle…", "Меня зовут…", "phrase"],
    ["Je ne comprends pas", "Я не понимаю", "phrase"],
    ["Parlez-vous anglais ?", "Вы говорите по-английски?", "phrase"],
    ["L'eau", "вода"],
    ["Le pain", "хлеб"],
    ["Le vin", "вино"],
  ],
});

export const IT_RU_BASIC = starterDeck({
  id: "it-ru-basic-a1",
  name: "Итальянский — основы",
  name_en: "Italian — Basics",
  description: "Базовые итальянские фразы и повседневная лексика.",
  description_en: "Basic Italian phrases and everyday vocabulary.",
  sourceLang: "it",
  targetLang: "ru",
  topic: "basic",
  ageGroup: "adult",
  level: "A1",
  cards: [
    ["Ciao", "Привет / Пока"],
    ["Buongiorno", "Добрый день / Доброе утро"],
    ["Buonasera", "Добрый вечер"],
    ["Buonanotte", "Спокойной ночи"],
    ["Arrivederci", "До свидания"],
    ["Per favore", "Пожалуйста", "phrase"],
    ["Grazie", "Спасибо"],
    ["Prego", "Пожалуйста (в ответ) / Прошу"],
    ["Scusa / Scusi", "Извини / Извините", "phrase"],
    ["Sì", "Да"],
    ["No", "Нет"],
    ["Come stai?", "Как дела?", "phrase"],
    ["Sto bene", "Всё хорошо", "phrase"],
    ["Come ti chiami?", "Как тебя зовут?", "phrase"],
    ["Mi chiamo…", "Меня зовут…", "phrase"],
    ["Non capisco", "Я не понимаю", "phrase"],
    ["Acqua", "вода"],
    ["Pane", "хлеб"],
    ["Vino", "вино"],
    ["Pizza", "пицца"],
  ],
});
